import { useRef, useState } from "react";
import { Mic, Square, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { t } from "@/i18n";

// post: (FormData) => Promise<{ data: { text: string } }>
export function DictateButton({ post, onText, testid, className = "", icon: Icon = Mic }) {
  const [state, setState] = useState("idle");
  const rec = useRef(null);
  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mr = new MediaRecorder(stream);
      const chunks = [];
      mr.ondataavailable = (e) => e.data.size && chunks.push(e.data);
      mr.onstop = async () => {
        stream.getTracks().forEach((tr) => tr.stop());
        const type = mr.mimeType || "audio/webm";
        const fd = new FormData();
        fd.append("file", new Blob(chunks, { type }), `voice.${type.includes("mp4") ? "mp4" : "webm"}`);
        setState("busy");
        try {
          const { data } = await post(fd);
          if (data.text) onText(data.text); else toast(t("I didn't catch that — try again"));
        } catch (e) { toast.error(e?.response?.data?.detail || t("Something went wrong")); }
        setState("idle");
      };
      rec.current = mr;
      mr.start();
      setState("rec");
    } catch { toast.error(t("Microphone not available")); }
  };
  const stop = () => rec.current?.state === "recording" && rec.current.stop();
  return (
    <button type="button" disabled={state === "busy"} onClick={state === "rec" ? stop : start}
      className={`w-10 h-10 rounded-full grid place-items-center shrink-0 transition-colors ${state === "rec" ? "bg-[var(--status-error)] text-white" : "faint hover:text-[var(--text-primary)] hover:bg-[var(--bg-surface-hover)]"} ${className}`}
      title={t(state === "rec" ? "Stop and type it out" : "Speak instead of typing")} data-testid={testid}>
      {state === "busy" ? <Loader2 size={18} className="animate-spin" /> : state === "rec" ? <Square size={16} /> : <Icon size={18} />}
    </button>
  );
}
